<template>
    <div>
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <!-- <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6> -->
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--8">
          <b-row>
              <b-col cols="12">
                 <b-card>
                    <div slot="header" class="mb-0">
                        <h3>{{language_terms['GTIN_ENTRY']}}</h3>
                    </div>
                    <b-row>
                        <b-col md="12">
                            <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                            <productLookup ref="productLookup" v-bind:url="apiProductLookup" v-on:selected="setProduct($event)" :lookupId="item.product_code"/>
                        </b-col>                        
                        <b-col md="12">
                            <base-input ref="gtinx" id="gtinx"
                                :label="language_terms['GTIN']"
                                placeholder="8, 10, 12, 13"
                                v-on:keyup.enter="clickOnAssign"
                                v-model="gtin">
                            </base-input>
                        </b-col>
                        <b-col cols="12" >
                            <!-- $picking -->
                            <v-client-table v-model="entries" v-if="entries.length > 0" :columns="entriesColumns" :options="entriesOptions">
                                <div slot="action" slot-scope="{index, row}">
                                    <b-button @click="clickOnDelete(index, row)"  variant="danger">
                                        <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                    </b-button>        
                                </div>
                            </v-client-table>
                        </b-col>

                    </b-row>
                 </b-card>
              </b-col>
          </b-row>
      </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
th.VueTables__sortable {
    color:rgb(255,255,255);
}
td.VueTables__row  {
    color:black
}
</style>

<script>
import { mapState } from 'vuex';

import { nextTick } from 'vue'
import Vue from 'vue'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import productLookup from "@/components/Autocomplete.vue";
import locationLookup from "@/components/Autocomplete.vue";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import BaseInput from '../../components/Inputs/BaseInput.vue';
import BaseRadio from '../../components/Inputs/BaseRadio.vue';

export default {
    components:{
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        productLookup,
        locationLookup,
        FormWizard,
        TabContent,
        BaseInput,
        BaseRadio
    },
    data(){
        return{
            entriesColumns:['id', 'sku','product_name', 'brand', 'gtin', 'action'],
            entriesOptions:{perPage:10000, perPageValues:[],stickyHeader:false, stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false
            ,texts:{count:"", filter: "", filterPlaceholder: "Quick Lookup",}
            ,editableColumns: ['qty_open']                        
            ,sortIcon: {
            is: "glyphicon-sort",
            base: "glyphicon",
            up: "glyphicon-chevron-up",
            down: "glyphicon-chevron-down"
            },
            sortingAlgorithm(data, column) {
            return data.sort(this.getSortFn(column));
            },
            },
            entries:[],
            item:{product_code:null},
            gtin:'',
            product:{id:''},
            loadCounter:0,
            filter:[], 
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
        }
    },
      computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
        })
    },
    async mounted(){

    },
    methods: 
    {
        async clickOnDelete(index, row)
        {
            let payload = {id: row.id}
            axios.post(apiRoutes["DELETE_PRODUCT_CODE"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.loadCounter--
                    this.product.id = ''
                    this.gtin = ''
                    this.item = []

                    Vue.notify({
                        group: "notify",
                        type: "success",
                        text: 'GTIN Deleted',
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });

                    this.entries.splice(index - 1, 1);
                }
                else
                {
                    this.loadCounter--
                    Vue.notify({
                        group: "notify",
                        type: "error",
                        text: response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });
                }
            })
            .catch((error) => 
            {
                this.loadCounter--
                if (error.response) 
                {
                    Vue.notify({
                        group: "notify",
                        type: "error",
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });
                } 
                else 
                {
                    console.log("Problem Querying Data", error);
                }
            });

        },
        async confirmGTINAssignment()
        {
            this.loadCounter++

            let gtin = this.gtin
            let product = this.product

            let payload = {code: gtin, product_id: product.id, tag: 'GTIN', type: 'barcode_upc'}
            axios.post(apiRoutes["CREATE_PRODUCT_CODE"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.loadCounter--
                    this.product.id = ''
                    this.gtin = ''
                    this.item = []

                    Vue.notify({
                        group: "notify",
                        type: "success",
                        text: 'GTIN Assigned',
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });

                    let e = {'id':response.data.msg, 'sku':product.code, 'product_name': product.name, 'brand': product.brand, 'gtin': gtin, 'action': ''}
                    this.entries.unshift(e)
                }
                else
                {
                    this.loadCounter--
                    Vue.notify({
                        group: "notify",
                        type: "error",
                        text: response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });
                }
            })
            .catch((error) => 
            {
                this.loadCounter--
                if (error.response) 
                {
                    Vue.notify({
                        group: "notify",
                        type: "error",
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300,
                    });
                } 
                else 
                {
                    console.log("Problem Querying Data", error);
                }
            });

            this.$refs.productLookup.$el.children[0].focus();
        },
        async clickOnAssign(obj)
        {
            if (this.product.id != '' && this.gtin != '')
            {
                let l = this.gtin.length
                if (l != 8 && l != 10 && l != 12 && l != 13 && 0)
                {
                    alert('Invalid GTIN')
                }
                else
                {
                    await this.confirmGTINAssignment()

                    // let response = await this.$confirm(this.language_terms['PROCEED'] + '?', this.language_terms['CONFIRMATION'], {
                    // confirmButtonText: this.language_terms['YES'],
                    // cancelButtonText: this.language_terms['CANCEL'],
                    // type: 'warning'
                    // }).catch(() => {
                    // this.$message.info(this.language_terms['ACTION_CANCEL'])
                    // })
                    // if (response === 'confirm') {
                    //     await this.confirmGTINAssignment()
                    // }                    
                    // this.modalConfirmation = true
                }
            }
            
        },
        async setProduct(obj)
        {
            this.$refs.gtinx.$el.children[0].focus();
            this.product = obj
            if (this.product.id == '')
            {
                this.gtin = ''
                this.item = []
            }
        },
    }
}

</script>
